export const BASIC_ROOT_ROUTE = '/'
export const HOME_ROOT_ROUTE = '/home/overview'
export const TERMS_CONDITIONS_LINK = 'https://www.envitainc.com/terms-conditions/'
export const COPYRIGHT_LINK = 'https://www.envitainc.com/privacy-policy/'
